type Props = {
  ordering: string
  setOrdering: (value: string) => void
  itemOrder: string
  children: React.ReactNode
}
export const OrderHeader = (props: Props) => {
  const { ordering, setOrdering, itemOrder } = props
  const reverse = ordering.startsWith('-')
  const normalizedOrdering = reverse ? ordering.slice(1) : ordering

  const handleClick = () => {
    const newOrdering = normalizedOrdering === itemOrder ? (reverse ? '' : '-') + itemOrder : itemOrder
    setOrdering(newOrdering)
  }
  return (
    <span onClick={handleClick} className="capitalize cursor-pointer hover:underline select-none">
      {props.children}
      {normalizedOrdering === itemOrder && <>{reverse ? ' ⬇' : ' ⬆'}</>}
    </span>
  )
}
